import { EmailAddress } from "@/models/api/mail/EmailAddress";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsOptional, IsString, ValidateNested, IsArray } from "class-validator";

export class NotificationStatus {
  @IsString()
  @Expose()
  sendStatusString!: string;
  @IsString()
  @Expose()
  emailTypeString!: string;
  @IsOptional()
  @IsString()
  @Expose()
  sendDate!: null | string;
  @Type(() => EmailAddress)
  @ValidateNested()
  @Expose()
  emails!: Array<EmailAddress>;
  @Expose()
  @IsArray()
  attachmentName!: Array<string>;
}

export class DocumentMailNotification {
  @Expose()
  @IsString()
  documentId!: string;
  @Expose()
  @IsString()
  documentNumber!: string;
  @Expose()
  @IsOptional()
  @IsNumber()
  mailNotificationId!: number | null;
  @IsOptional()
  @IsString()
  @Expose()
  openDate!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  comment!: string | null;
  @Expose()
  notificationStatuses!: Array<NotificationStatus>;
}

export type DocumentMailNotificationResponse = Array<DocumentMailNotification>;

export class SaveDocumentMailNotificationStatus {
  @Expose()
  @IsString()
  documentId!: string;
  @Expose()
  @IsOptional()
  @IsString()
  openDate!: string | null;
  @Expose()
  @IsOptional()
  @IsString()
  comment!: string | null;

  static fromDocumentMailNotification(v: DocumentMailNotification): SaveDocumentMailNotificationStatus {
    const r = new SaveDocumentMailNotificationStatus();
    r.documentId = v.documentId;
    r.comment = v.comment;
    r.openDate = v.openDate;
    return r;
  }
}
